import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { FilteredS3ResourceItem } from "@/services/cloudchipr.api";
import { LifecycleRulesCellRenderer } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/lifecycle-rules/LifecycleRulesCellRenderer";

export const lifecycleRulesColumnDef: ColDef<FilteredS3ResourceItem> = {
  minWidth: 210,
  sortable: false,
  field: "resource.lifecycle_rule_names",
  headerName: "Lifecycle Rules",
  valueGetter: ({ data }) =>
    data?.resource?.lifecycle_rule_names?.length
      ? data.resource.lifecycle_rule_names.join(", ")
      : "Not configured",
  cellRenderer: ({ data }: CustomCellRendererProps<FilteredS3ResourceItem>) => (
    <LifecycleRulesCellRenderer data={data?.resource} />
  ),
};
